// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"so_a bhl_rc bhl_qx bhl_xr","ContestPosts__more":"so_b bhl_vu bhl_b bhl_va bhl_sv"};